import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import contestsListSaga from './sagas/contestsListSaga';

export default [
  // Lists
  ...createCombineMapItem('contestsList', createListReduceObject, [
    contestsListSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/lists/reducersMap.js